

















































































import {
    Table,
    TableOptions,
    getTableCaption,
    TableConfig,
    defaultTableConfig,
    columnTemplates,
} from '@/core/components/table';
import { Component } from 'vue-property-decorator';
import DxDataSource from 'devextreme/data/data_source';
import { DxDataGrid, DxColumn, DxLookup } from 'devextreme-vue/data-grid';
import container from '@/container';
import { Page } from '@/core/components/controls';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { DataSource } from '@/types';
import {
    StructuredResult,
    UsageResourcesInfo,
    Site,
    ResourceType,
} from '@/dto';
import {
    CONTRACTS,
    FetchServiceContract,
    EventsServiceContract,
    Events,
} from '@/core/contracts';
import { ContextsState } from '@/store';
import Query from 'devextreme/data/query';

@Component({
    components: {
        TableOptions,
        DxDataGrid,
        DxColumn,
        DxLookup,
    },
})
export default class UsageResources extends Page {
    public table: Table | null = null;
    private items: UsageResourcesInfo[] = [];
    private strings: string[] = [];
    private sites: Site[] = [];
    private resourceTypes: ResourceType[] = [];
    private tableKey: string = 'usage-resources-control';

    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    private get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this),
        };
    }

    public setTable(table: Table): void {
        this.table = table;
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public mounted() {
        const table = this.$refs['data-grid'] as DxDataGrid;
        this.table = table.instance!;
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get dataSource(): DataSource {
        return new DxDataSource({
            load: this.load,
        });
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get filteredData(): UsageResourcesInfo[] {
        const filterExpr = this.table!.getCombinedFilter();
        return filterExpr
            ? Query(this.items).filter(filterExpr).toArray()
            : this.items;
    }

    private async load(): Promise<UsageResourcesInfo[]> {
        const contextId = ContextsState.currentContextId;
        const url = `/contexts/${contextId}/usageResources`;
        this.items = await container
            .get<FetchServiceContract>(CONTRACTS.FetchService)
            .get<StructuredResult<UsageResourcesInfo>>(url)
            .then(this.prepareData);

        return this.items ? this.items : [];
    }

    private prepareData(data: StructuredResult<UsageResourcesInfo>): any {
        if (!(data && data.items && data.items.length > 0)) {
            return [];
        }

        this.resourceTypes = Object.values(data.resourceTypes);
        this.sites = Object.values(data.sites);
        this.strings = Object.values(data.strings);

        return data.items.map(item => {
            item.type = data.strings[item.typeId];
            return item;
        });
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private get columnTemplates() {
        return columnTemplates;
    }

    private getDisplayValue(rowInfo: any) {
        return rowInfo.productTypesIds
            ?.map((id: string) => {
                return this.resourceTypes?.find(
                    resource => resource.id === id
                )!.name;
            })
            .join(', ');
    }
}
